import React, { useLayoutEffect } from 'react';
import { Platform } from 'react-native';
import { useResponsive } from '@sg/garnish';

import { LoadingAnimation } from '../../components';
import { AccountSignedOutMessage } from '../../components/Account';
import { useIsLoggedIn, useIsLoggingIn } from '../../context/AuthMachine';
import type { AccountMenuScreenProps } from '../../navigation/AppNavigation.props';
import { ProfileScreen } from '../ProfileScreen';
import { AccountScreenContent } from './AccountScreen.content';

export const AccountScreen = (params: AccountMenuScreenProps) => {
  const { navigation } = params;
  const { currentBreakpoint } = useResponsive();

  const isLoggedIn = useIsLoggedIn();
  const isLoggingIn = useIsLoggingIn();

  useLayoutEffect(() => {
    if (navigation) {
      navigation.setOptions({ headerShown: !currentBreakpoint.isXS });
    }
  }, [navigation, currentBreakpoint.isXS]);

  if (isLoggingIn) return <LoadingAnimation />;

  if (!isLoggedIn && Platform.OS === 'web') {
    return <AccountSignedOutMessage />;
  }

  if (!currentBreakpoint.isXS && isLoggedIn) {
    return <ProfileScreen />;
  }

  return <AccountScreenContent />;
};
